"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = PlainWizard;

var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _reactI18next = require("react-i18next");

var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _Context = _interopRequireDefault(require("../../Context"));

var _GenericStore = require("../store/GenericStore");

var _Component = _interopRequireDefault(require("../../render/Component"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid/Grid"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: '100%',
      flexGrow: 1,
      background: 'initial'
    },
    dots: {
      width: '100%',
      justifyContent: 'center',
      position: 'absolute',
      bottom: '12px',
      left: '0'
    },
    dot: {
      opacity: 1,
      background: '#bbb9ad'
    },
    dotActive: {
      background: '#8E0638'
    },
    button: {
      fontWeight: '900'
    },
    header: {
      background: '#F7DCBB',
      padding: theme.spacing(2),
      paddingTop: '0',
      fontFamily: 'FedraSerifAProBold !important',
      fontSize: '1.5em',
      fontWeight: '900',
      position: 'relative',
      color: '#8E0638'
    }
  };
});

var isStepActive = function isStepActive(step, wizardStoreValue) {
  if (!step.hasOwnProperty('conditions')) return true;
  var isActive = true;
  if (wizardStoreValue && step) step.conditions.forEach(function (condition) {
    if (!wizardStoreValue.hasOwnProperty(condition.path) || wizardStoreValue[condition.path] !== condition.value) isActive = false;
  });
  return isActive;
};

var getSteps = function getSteps(block, parentPath, wizardStoreValue) {
  return block.content.filter(function (step) {
    return isStepActive(step, wizardStoreValue);
  });
};

function PlainWizard(props) {
  var _useContext = (0, _react.useContext)(_Context["default"]),
      onCancel = _useContext.onCancel,
      setOnNext = _useContext.setOnNext;

  var block = props.block,
      parentPath = props.parentPath,
      onSubmit = props.onSubmit;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      wizardStoreValue = _useDataStore2[0],
      setWizardStoreValue = _useDataStore2[1];

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var theme = (0, _useTheme["default"])();
  var classes = useStyles();

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(new _set["default"]()),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      skipped = _React$useState4[0],
      setSkipped = _React$useState4[1];

  var steps = getSteps(block, parentPath, wizardStoreValue);
  var activeStepContent = steps[activeStep];

  var isStepOptional = function isStepOptional(step, block) {
    var stepObj = {};

    for (var o in block.content) {
      if (block.content[o].step === step) stepObj = block.content[o];
    }

    return stepObj.hasOwnProperty('isOptional') && stepObj.isOptional;
  };

  var isStepSkipped = function isStepSkipped(step) {
    return skipped.has(step);
  };

  var handleNext = function handleNext() {
    var newSkipped = skipped;

    if (isStepSkipped(activeStep)) {
      newSkipped = new _set["default"](newSkipped.values());
      newSkipped["delete"](activeStep);
    }

    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    setSkipped(newSkipped);
    setTimeout(function () {
      return window.scrollTo(0, 0);
    }, 200);
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
    setTimeout(function () {
      return window.scrollTo(0, 0);
    }, 200);
  };

  var handleSkip = function handleSkip() {
    if (!isStepOptional(activeStep, block)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
    setSkipped(function (prevSkipped) {
      var newSkipped = new _set["default"](prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  var handleReset = function handleReset() {
    setActiveStep(0);
  };

  (0, _react.useEffect)(function () {
    setOnNext({
      onNext: handleNext
    });
  }, [activeStep]);
  console.log('WizardStoreValue: ', wizardStoreValue);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, block.label && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.header
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    justify: 'space-between'
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: handleBack,
    disabled: activeStep === 0,
    className: classes.button
  }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], null), " ", t('BTN_BACK')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: onCancel.onCancel,
    className: classes.button
  }, t('BTN_CANCEL'))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, t(block.label))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      textAlign: 'center',
      marginTop: '0px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Component["default"], {
    block: activeStepContent,
    parentPath: parentPath,
    onSubmit: onSubmit
  })));
}